export default __webpack_public_path__ + "static/media/img-600x400-2.722a3039.jpg";